import { h } from 'preact'

import InputGroup from '../../control-components/ui-components/InputGroup'
import { Message } from '../../control-components/ui-components/Message'

interface Props {
  credentials: { id: string, secret: string }
}

const Credentials = ({ credentials }: Props) => {
  return (
    <section>
      <InputGroup newStyle title='Client ID' value={credentials.id} disabled />
      <InputGroup newStyle title='Client secret' value={credentials.secret} disabled />
      <Message variant='warning'>
        <div>
          <p>Make sure you copy and store your Client ID and Client Secret - we won’t show them again after you leave this page.</p>
          <p>Take care to keep your client credentials secure.</p>
          <p>Publicly exposing your credentials can result in your account being compromised, which could lead to unexpected/malicious behaviour on your community.</p>
        </div>
      </Message>
    </section>
  )
}

export default Credentials
